import { render, staticRenderFns } from "./UserTokens.vue?vue&type=template&id=728cd222&"
import script from "./UserTokens.vue?vue&type=script&lang=js&"
export * from "./UserTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports